import { showSnackbar } from '../../../api/snackbarSlice';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { apiClient } from '../../../utils/axios';
import { useTranslatedMessages } from '../../../hooks/useTranslatedMessages';

export const deleteProducts = async (payload) => {
  const { data } = await apiClient.delete(`/products/${payload.id}`);
  return data;
};

export const useDeleteProductHandler = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const { snackbarMessages } = useTranslatedMessages();
  const productMessages = snackbarMessages.products ?? {};

  const mutation = useMutation({
    mutationFn: deleteProducts,
    onSuccess: () => {
      dispatch(
        showSnackbar({
          message: productMessages.product_delete_success,
        }),
      );
      queryClient.invalidateQueries({ queryKey: ['products'] });
    },
    onError: (error) => {
      dispatch(showSnackbar({ message: error, severity: 'error' }));
    },
  });

  const submit = async (data) => {
    mutation.mutate(data);
  };

  return {
    data: mutation.data,
    isError: mutation.isError,
    error: mutation.error,
    isPending: mutation.isPending,
    isSuccess: mutation.isSuccess,
    onDelete: submit,
  };
};
